function FragmentsFormController(stateService, CommonService, toasterService) {
  const ctrl = this;
  const getAudioSegment = CommonService.getAudioSegment;
  const preLoadAudio = CommonService.preLoadAudio;

  ctrl.$onInit = async () => {
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    stateService.getSegments().then(data => ctrl.segments = data);
    if (!ctrl.selection) {
      ctrl.viewMode = false;
      ctrl.fragment = {
        segments: [],
        id: -1,
        fragment_type: 'GENERIC' // Only viable option right now.
      };
      ctrl.newFragment = true;
    } else {
      ctrl.loading = true;
      ctrl.viewMode = true;
      ctrl.fragment = await stateService.getFragment(ctrl.workspaceId, ctrl.selection.id);
      ctrl.fragment.segments = angular.copy(ctrl.fragment.files);
      ctrl.audioSegment = getAudioSegment(ctrl.fragment.segments);
      ctrl.filteredFiles = preLoadAudio(ctrl.audioSegment);
    }
  };

  ctrl.checkValidity = () => {
    return ctrl.fragment.segments.length === 0 || ctrl.duplicateName;
  };

  ctrl.onEditSegments = event => {
    ctrl.fragment.segments = event.segments;
  };

  ctrl.toggleEditMode = async(value) => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      // Reapply the current fragment data if the user makes changes and presses 'Cancel'
      ctrl.fragment = await stateService.getFragment(ctrl.workspaceId, ctrl.selection.id)
      ctrl.fragment.segments = ctrl.fragment.files;
      ctrl.viewMode = true;
    }
  };

  ctrl.clearForm = () => {
    ctrl.fragmentForm.$setPristine(true);
    ctrl.fragmentForm.$setUntouched(true);
    ctrl.fragment = {
      name: null,
      segments: [],
      id: -1,
      fragment_type: 'GENERIC'
    };
    ctrl.duplicateName = false;
  };

  ctrl.checkName = () => {
    if (!ctrl.fragment.name) return;
    ctrl.duplicateName = ctrl.fragments
      .map(f => (f.name.replace(/(\r\n|\n|\r)/gm, "").toLowerCase()))
      .find(fragName => fragName === ctrl.fragment.name.toLowerCase()) ? true : false;
  };

  ctrl.onSubmit = () => {
    if (ctrl.newFragment) {
      let updateObject = Object.assign({}, ctrl.fragment);
      updateObject.segments = updateObject.segments.map(s => {
        if (s.id) return { number: s.id };
        return { new_segment: s };
      });
      stateService.createFragment(ctrl.workspaceId, updateObject).then(
        function (response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-new-fragment-successful');
        },
        function (e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-new-fragment-failure');
          console.log(e);
        }
      );
    } else {
      let updateObject = Object.assign({}, ctrl.fragment);
      updateObject.segments = updateObject.segments.map(s => {
        if (s.id) return { number: s.id };
        return { new_segment: s };
      });
      let editObject = {
        segments: updateObject.segments,
        name: ctrl.fragment.name,
      };
      stateService.editFragment(ctrl.workspaceId, updateObject.id, editObject).then(
        function (response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-fragment-successful');
        },
        function (e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-edit-fragment-failure');
          console.log(e);
        }
      );
    }
  };
}

angular
  .module('pis-tool.module')
  .controller('FragmentsFormController', FragmentsFormController);
